import { Injectable } from "@nestjs/common";
import { DataSource, Repository } from "typeorm";
import { SectionWiseModel } from "../../model-paper/entities/section-wise-model.entity";

@Injectable()
export class SectionWiseModelRepo extends Repository<SectionWiseModel>{
    constructor(private dataSource: DataSource) {
        super(SectionWiseModel, dataSource.createEntityManager());
    }
}